import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { AppInsightsService } from '@markpieszak/ng-application-insights';

import { ConfigService } from '../../core/config.service';
import { RequestResultType } from '../domain/enums/request-result-type';
import { RequestResult } from '../domain/models';
import { JwtDecoded } from '../domain/models/authentication/jwt-decoded';
import { LoginService } from './services/login.service';
import { LoginViewModel } from './view-models/login.view-model';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
    public loginForm: FormGroup;
    public loginVm: LoginViewModel;
    public appVersion: string;

    private validCredentials: boolean;
    private serverError: boolean;
    private hasSubmitted: boolean;
    private isLocked: boolean;

    constructor(
        private loginService: LoginService,
        private configService: ConfigService,
        private appInsightsService: AppInsightsService,
        private router: Router) {
    }

    ngOnInit(): void {
        this.appVersion = this.configService.getEnv('version');
        this.loginVm = new LoginViewModel();
        this.loginForm = this.loginVm.toFormGroup();
        this.hasSubmitted = false;
        this.validCredentials = true;
        this.serverError = false;
    }

    onLoginClick(): void {
        this.hasSubmitted = true;
        this.validCredentials = true;
        this.serverError = false;

        if (this.loginForm.invalid) {
            return;
        }

        this.isLocked = true;
        this.loginForm.disable();
        this.loginService.login(this.loginVm).subscribe((loginResult: RequestResult<any>) => {
            if (loginResult.requestResultType === RequestResultType.Success) {
                const jwtDecoded: JwtDecoded = this.loginService.getDecodedAccessToken();
                this.appInsightsService.setAuthenticatedUserContext(jwtDecoded.sub, jwtDecoded.email);
                this.appInsightsService.trackTrace('STREET_PORTAL: User ' + jwtDecoded.email + ' logged in at ' + new Date(Date.now()));
                this.router.navigate(['/distributions']);
            } else if (loginResult.requestResultType === RequestResultType.InvalidCredentials) {
                this.validCredentials = false;
            } else {
                this.serverError = true;
            }
            this.isLocked = false;
            this.loginForm.enable();
        });
    }

    isEmailValid(): boolean {
        let emailfield: AbstractControl = this.loginForm.controls.email;
        return !(emailfield.invalid && (emailfield.touched || emailfield.dirty || this.hasSubmitted));
    }

    isPasswordValid(): boolean {
        let passwordfield: AbstractControl = this.loginForm.controls.password;
        return !(passwordfield.invalid && (passwordfield.touched || passwordfield.dirty || this.hasSubmitted));
    }

    areCredentialsValid(): boolean {
        return this.validCredentials;
    }

    serverErrorOccured(): boolean {
        return this.serverError;
    }

    isFormLocked(): boolean {
        return this.isLocked;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/login/login.component.ts